import angular from 'angular';
import gettext from 'angular-gettext';
import config from '../../ConfigModule/ConfigModule';
import Dropzone from 'dropzone';
import AuthServiceModule from '../../Auth/CMSAuthService';
import MediaResource from '../MediaResource'

export default angular.module('cms.media.dropzone', [config, AuthServiceModule, MediaResource, gettext])
    .component('mediaDropzone', {
        template: require('./media-dropzone.html'),
        bindings: {
            onUploadAdded: '&',
            onUploadUpdated: '&',
            onUploadSuccess: '&',
            onUploadError: '&'
        },
        controller: function ($scope, $element, CONFIG, CMSAuthService, MediaResource, gettextCatalog, $rootScope) {
            /** @ngInject */
            let globalDropzone = null;
            this.$onInit = () => {
                globalDropzone = new Dropzone($element.find('.media-dropzone')[0], {
                    url: () => CONFIG.API_URL + "/media?Authorization=" + CMSAuthService.getToken(),
                    headers: {
                        'Cache-Control': null,
                        'X-Requested-With': null
                    },
                    previewTemplate: `<div></div>`,
                    dictDefaultMessage: gettextCatalog.getString("Drop files here or click to upload", null, "Dropzone.js option"),
                    dictFallbackMessage: gettextCatalog.getString("Your browser does not support drag'n'drop file uploads.", null, "Dropzone.js option"),
                    dictFallbackText: gettextCatalog.getString("Please use the fallback form below to upload your files like in the olden days.", null, "Dropzone.js option"),
                    dictFileTooBig: gettextCatalog.getString("File is too big ({{filesize}}MiB). Max filesize: {{maxFilesize}}MiB.", null, "Dropzone.js option"),
                    dictInvalidFileType: gettextCatalog.getString("You can't upload files of this type.", null, "Dropzone.js option"),
                    dictResponseError: gettextCatalog.getString("Server responded with {{statusCode}} code.", null, "Dropzone.js option"),
                    dictCancelUpload: gettextCatalog.getString("Cancel upload", null, "Dropzone.js option"),
                    dictCancelUploadConfirmation: gettextCatalog.getString("Are you sure you want to cancel this upload?", null, "Dropzone.js option"),
                    dictRemoveFile: gettextCatalog.getString("Remove file", null, "Dropzone.js option"),
                    dictMaxFilesExceeded: gettextCatalog.getString("You can not upload any more files.", null, "Dropzone.js option"),
                });

                /**
                 * Fired when file added to queue
                 */
                globalDropzone.on("addedfile", (file) => {
                    this.onUploadAdded({file: file});
                });

                /**
                 * Fired when file is sending to backend
                 * Set type of file for backend
                 * Set xhr callback to handle timeout exception (not handled by Dropzone.js)
                 */
                globalDropzone.on("sending", (file, xhr, formData) => {
                    if (file.type.indexOf("image") === -1) {
                        formData.append("type", "file");
                    }

                    xhr.ontimeout = () => {
                        file.status = "error";
                        this.onUploadError({
                            uploadId: file.upload.uuid,
                            file: file,
                            message: gettextCatalog.getString('Upload timeout')
                        });
                    };
                });

                /**
                 * Fired when thumbnail is ready
                 */
                globalDropzone.on("thumbnail", (file) => {
                    this.onUploadUpdated({
                        uploadId: file.upload.uuid,
                        file: file
                    });
                });

                globalDropzone.on("success", (file, response) => {
                    this.onUploadSuccess({uploadId: file.upload.uuid, media: new MediaResource(response)})
                });

                globalDropzone.on("error", (file, responseData, response) => {

                    let message = gettextCatalog.getString('Upload error');

                    // Backend Validation Error
                    if(response && response.status === 400) {
                        message = Object.values(responseData).join(", ");
                    }

                    if(response && response.status === 401) {
                        $rootScope.$emit('event:auth-loginRequired');
                    }

                    // Other validation error
                    if(!response) {
                        message = gettextCatalog.getString('File is too big');
                    }

                    if (this.onUploadError) {
                        this.onUploadError({
                            uploadId: file.upload.uuid,
                            file: file,
                            message: message
                        })
                    }
                });
            };

            $scope.$on('gettextLanguageChanged', () => {
                globalDropzone.destroy();
                $element.find('.media-dropzone')[0].innerHTML = "";
                this.$onInit();
            })

        }
    })
    .name;


// WEBPACK FOOTER //
// ./src/cmsCore/MediaModules/MediaDropzone/MediaDropzoneModule.js